var buy = require('./component/buy');
